module.exports = __webpack_public_path__ + "static/media/youth.261b702e.jpg";